import { Component, ViewEncapsulation, OnInit, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { Data, AppService } from '../../app.service';
import { DatePipe } from '@angular/common'
import { MatSnackBar } from '@angular/material';


// ************************************************** DOWNLOAD APP COMPONENT CLASS ************************************************
@Component({
  selector: 'add-discount-app-page',
  templateUrl: './addDiscount.component.html',
  styleUrls: ['./addDiscount.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AddDiscountComponent implements OnInit {

  // variables
  private currencies: any;


  // -- FUNC Constructor
  constructor(public appService: AppService, public datepipe: DatePipe, public dialogRef: MatDialogRef<AddDiscountComponent>, public snackBar: MatSnackBar
              ) { }


  // -- FUNC Ng On Init
  ngOnInit() {

    // get currencies
    this.currencies = this.appService.getCurrencies();
  }


  // -- FUNC Ng After View Init
  ngAfterViewInit(){
    
  }


  // -- FUNC Close
  public close(): void {
    this.dialogRef.close();
  }


  // -- FUNC Get Proper Certificate End Date
  private getProperCertificateEndDate(endDate: string) {
    var endDateDate = new Date(endDate);
    let formatedEndDate = this.datepipe.transform(endDateDate, 'yyyy-MM-dd');
    return formatedEndDate;
  }


  // -- FUNC Get User Currency Sign
  public getUserCurrencySign() {
    var currency = this.currencies[this.appService.Data.user.currencyId];
    var sign;

    if (currency) {
      sign = currency.sign
    }
    else {
      sign = '¥';
    }

    return sign;

  }


  // -- FUNC Get Appropriate Coupon Sum Value
  public getAppropriateCouponSumValue(couponSum) {
    var currency = this.currencies[this.appService.Data.user.currencyId];

    if (currency.code != "USD") {
      var couponSumAppropriateValue = (couponSum * this.appService.Data.user.rmbDollarCurrencyRate) * this.appService.Data.user.currencyRate;
      return couponSumAppropriateValue;
    }
    else {
      return couponSum;
    }
  }


  // -- FUNC Handle Discount Certificate Selection
  private handleDiscountCertificateSelection(certificateId: string) {
    // iterate thru certificates array and set the appropriate isSelected value to all certificates 
    for (var i = 0; i < this.appService.Data.discountCertificatesArray.length; i++) {
      if (this.appService.Data.discountCertificatesArray[i].id == certificateId && this.appService.Data.discountCertificatesArray[i].isSelected != true) {
        this.appService.Data.discountCertificatesArray[i].isSelected = true;
      }
      else {
        this.appService.Data.discountCertificatesArray[i].isSelected = false;
      }
    }
  }


  // -- FUNC Handle Discount Coupon Selection
  private handleDiscountCouponSelection(couponId: string) {

    // find current coupon in the coupons array list
    let coupon = this.appService.Data.discountCouponsArray.filter(item => item.id == couponId)[0];

    if (coupon) {

      var couponCalculatedStartSum = Number(coupon.couponStartSum) * this.appService.Data.user.rmbDollarCurrencyRate;

      // check if order total sum is bigger then coupon start sum
      if (couponCalculatedStartSum < this.appService.Data.totalCartPrice) {

        // iterate thru coupons array and set the appropriate isSelected value to all coupons
        for (var i = 0; i < this.appService.Data.discountCouponsArray.length; i++) {
          if (this.appService.Data.discountCouponsArray[i].id == couponId && this.appService.Data.discountCouponsArray[i].isSelected != true) {
            this.appService.Data.discountCouponsArray[i].isSelected = true;
          }
          else {
            this.appService.Data.discountCouponsArray[i].isSelected = false;
          }
        }
      }
      // else if order total sum is smaller then coupon start sum then tell user that he can't use this coupon
      else {

        var couponStartSum = couponCalculatedStartSum * this.appService.Data.user.currencyRate;
        this.snackBar.open("К сожалению минимальная сумма заказа в котором можно использовать этот купон составляет " + couponStartSum.toFixed(2) + this.getUserCurrencySign(), '×', { panelClass: 'error', verticalPosition: 'top', duration: 5000 });

      }


    }

  }

}
